import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from 'common/theme/cryptoModern';
import { ResetCSS } from 'common/assets/css/style';
import Sticky from 'react-stickynode';
import Navbar from 'containers/CryptoModern/Navbar';
import Banner from 'containers/CryptoModern/Banner';
//import CountDown from 'containers/CryptoModern/CountDown';
import Features from 'containers/CryptoModern/FeatureSection';
import WorkHistory from 'containers/CryptoModern/WorkHistory';
import Investment from 'containers/CryptoModern/Investment';
import FundRaising from 'containers/CryptoModern/FundRaising';
//import Privacypolicy from 'containers/CryptoModern/Privacy';
import WalletSection from 'containers/CryptoModern/WalletSection';
import MapSection from 'containers/CryptoModern/MapSection';
//import FaqSection from 'containers/CryptoModern/FaqSection';
import Newsletter from 'containers/CryptoModern/Newsletter';
//import Joinwaitlist from 'containers/CryptoModern/Joinwaitlist';
import Footer from 'containers/CryptoModern/Footer';
import GlobalStyle, {
  CryptoWrapper,
  ContentWrapper,
} from 'containers/CryptoModern/cryptoModern.style';
import { Helmet } from 'react-helmet';
import GhostSignupPopup from '../components/GhostSignupPopup';


import Seo from 'components/seo';

const CryptoModern = () => {
  return (
    <ThemeProvider theme={theme}>
      <>

      <Helmet>
        {/* Meta Tags */}
        <title>NadiAI | Simplify the Enterprise with AI Agents</title>
        <meta name="description" content="Simplify the Enterprise with AI Agents. NadiAI provides cutting-edge AI agent platforms for business automation, workflow optimization, and enterprise efficiency solutions." />
        <meta name="keywords" content="AI agents, artificial intelligence platform, business automation, enterprise AI, workflow optimization, AI integration, automated solutions, NadiAI" />

        {/* Open Graph */}
        <meta property="og:title" content="NadiAI | Simplify the Enterprise with AI Agents" />
        <meta property="og:description" content="One Platform, Infinite Solutions. Leading AI agent platform for enterprise automation and business efficiency." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.nadiai.ai" />
        <meta property="og:site_name" content="NadiAI" />

        {/* Twitter Card */}
        <meta name="twitter:title" content="NadiAI | AI Agent Platform for Enterprise" />
        <meta name="twitter:description" content="Simplify the Enterprise with AI Agents. One Platform, Infinite Solutions for business automation." />
        <meta name="twitter:site" content="@nadiai" />

        {/* JSON-LD: Organization */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "NadiAI, Inc",
            "legalName": "NadiAI, Inc",
            "url": "https://www.nadiai.ai",
            "logo": {
              "@type": "ImageObject",
              "url": "https://www.nadiai.ai/icons/icon-512x512.png",
              "width": 512,
              "height": 512
            },
            "description": "Simplify the Enterprise with AI Agents. One Platform, Infinite Solutions. Leading provider of AI agent platforms for business automation and efficiency.",
            "foundingDate": "2023",
            "industry": "Artificial Intelligence",
            "keywords": [
              "AI agents",
              "artificial intelligence platform", 
              "business automation",
              "enterprise AI solutions",
              "AI integration",
              "automated workflows"
            ],
            "serviceArea": {
              "@type": "Place",
              "name": "Global"
            },
            "areaServed": "Worldwide",
            "sameAs": [
              "https://hub.nadiai.ai",
              "https://linkedin.com/company/nadiai",
              "https://twitter.com/nadiai"
            ],
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "customer service",
              "availableLanguage": "English"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "AI Agent Solutions",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "AI Agent Platform",
                    "description": "Comprehensive AI agent platform for enterprise automation"
                  }
                },
                {
                  "@type": "Offer", 
                  "itemOffered": {
                    "@type": "Service",
                    "name": "AI Integration Services",
                    "description": "Custom AI agent integration and deployment services"
                  }
                }
              ]
            }
          })}
        </script>

        {/* JSON-LD: WebSite */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "NadiAI",
            "alternateName": "NadiAI Platform",
            "url": "https://www.nadiai.ai",
            "description": "Simplify the Enterprise with AI Agents. One Platform, Infinite Solutions.",
            "publisher": {
              "@type": "Organization",
              "name": "NadiAI, Inc"
            },
            "potentialAction": {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": "https://www.nadiai.ai/search?q={search_term_string}"
              },
              "query-input": "required name=search_term_string"
            },
            "mainEntity": {
              "@type": "SoftwareApplication",
              "name": "NadiAI Platform",
              "applicationCategory": "BusinessApplication",
              "operatingSystem": "Web-based",
              "description": "AI agent platform that simplifies enterprise operations through intelligent automation",
              "offers": {
                "@type": "Offer",
                "category": "SaaS Platform"
              }
            }
          })}
        </script>

        {/* JSON-LD: TechArticle */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "headline": "AI Agent Platform Solutions for Enterprise",
            "description": "Comprehensive guide to implementing AI agents in enterprise environments for maximum efficiency and automation",
            "author": {
              "@type": "Organization",
              "name": "NadiAI, Inc"
            },
            "publisher": {
              "@type": "Organization",
              "name": "NadiAI, Inc"
            },
            "about": [
              { "@type": "Thing", "name": "Artificial Intelligence" },
              { "@type": "Thing", "name": "Business Automation" },
              { "@type": "Thing", "name": "Enterprise Software" }
            ],
            "keywords": "AI agents, enterprise automation, business intelligence, workflow optimization",
            "inLanguage": "en-US",
            "isAccessibleForFree": true
          })}
        </script>
      </Helmet>



        <ResetCSS />
        <GlobalStyle />

        <CryptoWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-active">
            <Navbar />
          </Sticky>
          <ContentWrapper>
          <GhostSignupPopup 
            showDelay={3000}      // 3 seconds delay
            showOnlyOnce={true}   // Save in localStorage
          />
            <Banner />
            {/*<CountDown />*/}
            <Features />
            <WorkHistory />
            <Investment />
            <FundRaising />
            {/*<Privacypolicy />*/}
            <WalletSection />
            <MapSection />
            {/*<FaqSection />*/}
            {/*<Newsletter />*/}
          </ContentWrapper>
          <Footer />
        </CryptoWrapper>
      </>
    </ThemeProvider>
  );
};
export default CryptoModern;
